import { jsx as t, jsxs as w } from "react/jsx-runtime";
import { c as de } from "react/compiler-runtime";
import { MenuItem as se, ListSubheader as ue, Select as me, FormControl as fe } from "@mui/material";
import { Grid as he } from "../Grid/Grid.js";
import { Typography as P } from "../Typography/Typography.js";
import xe from "@mui/icons-material/KeyboardArrowDown";
import ye from "@mui/icons-material/Warning";
import { styles as o } from "./Select.styles.js";
import { Box as f } from "../Box/Box.js";
import { Checkbox as ge } from "../Checkbox/Checkbox.js";
import { Divider as ve } from "../Divider/Divider.js";
import { FormLabel as We } from "../FormLabel/FormLabel.js";
import { Tooltip as be } from "../Tooltip/Tooltip.js";
function ke(l) {
  const e = de(83);
  let i, A, h, a, x, T, U, y, g, v, W, m, b, V, K, N, q, n, p;
  e[0] !== l ? ({
    id: W,
    width: p,
    height: U,
    DropdownIcon: i,
    options: b,
    placeholder: v,
    value: n,
    variant: V,
    size: K,
    sx: m,
    customFooter: h,
    children: A,
    emptyStateText: N,
    groupWarnings: T,
    error: a,
    errorText: x,
    label: y,
    valueLayout: q,
    ...g
  } = l, e[0] = l, e[1] = i, e[2] = A, e[3] = h, e[4] = a, e[5] = x, e[6] = T, e[7] = U, e[8] = y, e[9] = g, e[10] = v, e[11] = W, e[12] = m, e[13] = b, e[14] = V, e[15] = K, e[16] = N, e[17] = q, e[18] = n, e[19] = p) : (i = e[1], A = e[2], h = e[3], a = e[4], x = e[5], T = e[6], U = e[7], y = e[8], g = e[9], v = e[10], W = e[11], m = e[12], b = e[13], V = e[14], K = e[15], N = e[16], q = e[17], n = e[18], p = e[19]);
  let X;
  e[20] !== b ? (X = b === void 0 ? [] : b, e[20] = b, e[21] = X) : X = e[21];
  const c = X, E = V === void 0 ? "outlined" : V, Y = K === void 0 ? "small" : K, te = N === void 0 ? "No options available" : N, S = q === void 0 ? "ellipsis" : q, ae = Y === "medium" ? "40px" : "32px", oe = p != null, J = !!g.fullWidth && !oe, I = oe ? p : J ? "100%" : "auto", pe = n == null || n === "" || Array.isArray(n) && n.length === 0, d = !J && !oe && pe && !v ? o.emptySelectMinWidth : void 0;
  let M;
  e[22] !== I || e[23] !== d ? (M = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: I,
    ...d
  }, e[22] = I, e[23] = d, e[24] = M) : M = e[24];
  let B;
  e[25] !== I || e[26] !== d ? (B = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: I,
    ...d
  }, e[25] = I, e[26] = d, e[27] = B) : B = e[27];
  let C;
  e[28] !== y ? (C = y && /* @__PURE__ */ t(We, { component: "legend", sx: o.label, children: y }), e[28] = y, e[29] = C) : C = e[29];
  let L;
  e[30] !== W ? (L = {
    id: W
  }, e[30] = W, e[31] = L) : L = e[31];
  const le = `${W}-label`;
  let O;
  e[32] !== i ? (O = (s) => i ? /* @__PURE__ */ t(i, { ...s }) : /* @__PURE__ */ t(xe, { ...s }), e[32] = i, e[33] = O) : O = e[33];
  const ne = U ?? ae;
  let R;
  e[34] !== d || e[35] !== ne || e[36] !== p ? (R = {
    width: p,
    height: ne,
    ...d
  }, e[34] = d, e[35] = ne, e[36] = p, e[37] = R) : R = e[37];
  const re = S === "wrap" && o.commonWrap;
  let z;
  e[38] !== m ? (z = Array.isArray(m) ? m : [m], e[38] = m, e[39] = z) : z = e[39];
  let D;
  e[40] !== R || e[41] !== re || e[42] !== z ? (D = [R, o.common, re, ...z], e[40] = R, e[41] = re, e[42] = z, e[43] = D) : D = e[43];
  let Z;
  e[44] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Z = {
    sx: {
      "& .MuiList-root": {
        padding: "0px"
      }
    }
  }, e[44] = Z) : Z = e[44];
  let $;
  e[45] !== c || e[46] !== v || e[47] !== S ? ($ = (s) => {
    const ie = Array.isArray(s), u = S === "wrap" ? o.valueTextWrap : o.valueTextEllipsis;
    if (!s && s !== 0 || ie && s.length === 0)
      return /* @__PURE__ */ t(f, { component: "span", sx: [o.valueRoot, S === "wrap" && o.valueRootWrap], children: /* @__PURE__ */ t(P, { component: "span", sx: u, color: Te, children: v }) });
    if (ie) {
      const r = (c?.filter((ce) => s.includes(ce.value))).map(Ae).join(", ");
      return /* @__PURE__ */ t(f, { component: "span", sx: [o.valueRoot, S === "wrap" && o.valueRootWrap], children: /* @__PURE__ */ t(P, { component: "span", sx: u, children: r }) });
    }
    const ee = c?.find((Q) => Q.value === s);
    return /* @__PURE__ */ t(f, { component: "span", sx: [o.valueRoot, S === "wrap" && o.valueRootWrap], children: /* @__PURE__ */ w(f, { component: "span", sx: o.selectedContainer, children: [
      ee?.icon ? /* @__PURE__ */ t(f, { component: "span", sx: {
        display: "inline-flex",
        flexShrink: 0,
        alignItems: "center"
      }, children: ee.icon }) : null,
      /* @__PURE__ */ t(f, { component: "span", sx: u, children: ee?.label })
    ] }) });
  }, e[45] = c, e[46] = v, e[47] = S, e[48] = $) : $ = e[48];
  let j;
  e[49] !== te || e[50] !== T || e[51] !== c || e[52] !== n ? (j = c.length === 0 ? /* @__PURE__ */ t(se, { disabled: !0, sx: {
    opacity: "1 !important"
  }, children: /* @__PURE__ */ t(P, { sx: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#878787"
  }, children: te }) }) : (() => {
    const s = c?.reduce(we, {});
    return Array.from(new Set(c?.map(Se))).flatMap((u) => {
      const Q = s?.[u]?.map((r) => /* @__PURE__ */ w(se, { "data-test-id": `select-option-${r.id}`, value: r.value, sx: {
        display: "flex",
        gap: 1
      }, disabled: r.disabled, children: [
        Array.isArray(n) && /* @__PURE__ */ t(ge, { checked: n?.includes(r.value) }),
        r.icon,
        /* @__PURE__ */ t(P, { sx: {
          fontSize: "12px",
          fontWeight: 400
        }, children: r.label })
      ] }, r.id));
      if (u) {
        const r = T?.[u];
        return [/* @__PURE__ */ t(ue, { sx: o.groupHeader, children: /* @__PURE__ */ w(he, { container: !0, sx: o.groupHeaderContainer, children: [
          /* @__PURE__ */ t(P, { sx: o.groupHeaderText, children: u }),
          r && /* @__PURE__ */ t(be, { title: r, children: /* @__PURE__ */ t(ye, { sx: o.groupWarningIcon }) })
        ] }) }, `group-${u}`), ...Q];
      }
      return Q;
    });
  })(), e[49] = te, e[50] = T, e[51] = c, e[52] = n, e[53] = j) : j = e[53];
  let F;
  e[54] !== h ? (F = h && /* @__PURE__ */ w(f, { children: [
    /* @__PURE__ */ t(ve, { sx: {
      marginTop: "8px",
      marginBottom: "8px",
      borderColor: "#EBEBEB"
    } }),
    h
  ] }), e[54] = h, e[55] = F) : F = e[55];
  let H;
  e[56] !== A || e[57] !== g || e[58] !== Y || e[59] !== L || e[60] !== le || e[61] !== O || e[62] !== D || e[63] !== $ || e[64] !== j || e[65] !== F || e[66] !== n || e[67] !== E ? (H = /* @__PURE__ */ w(me, { inputProps: L, labelId: le, displayEmpty: !0, IconComponent: O, sx: D, MenuProps: Z, renderValue: $, value: n, variant: E, size: Y, ...g, children: [
    j,
    F,
    A
  ] }), e[56] = A, e[57] = g, e[58] = Y, e[59] = L, e[60] = le, e[61] = O, e[62] = D, e[63] = $, e[64] = j, e[65] = F, e[66] = n, e[67] = E, e[68] = H) : H = e[68];
  let k;
  e[69] !== a || e[70] !== J || e[71] !== H || e[72] !== B || e[73] !== C || e[74] !== E ? (k = /* @__PURE__ */ w(fe, { variant: E, hiddenLabel: !0, error: a, fullWidth: J, sx: B, children: [
    C,
    H
  ] }), e[69] = a, e[70] = J, e[71] = H, e[72] = B, e[73] = C, e[74] = E, e[75] = k) : k = e[75];
  let G;
  e[76] !== a || e[77] !== x ? (G = a && x && /* @__PURE__ */ t(P, { sx: o.errorText, children: x }), e[76] = a, e[77] = x, e[78] = G) : G = e[78];
  let _;
  return e[79] !== k || e[80] !== G || e[81] !== M ? (_ = /* @__PURE__ */ w(f, { sx: M, children: [
    k,
    G
  ] }), e[79] = k, e[80] = G, e[81] = M, e[82] = _) : _ = e[82], _;
}
function Se(l) {
  return l.group || "";
}
function we(l, e) {
  const i = e.group || "";
  return l[i] || (l[i] = []), l[i].push(e), l;
}
function Ae(l) {
  return l?.label;
}
function Te(l) {
  return l.vars?.palette.grey[500] ?? l.palette.grey[500];
}
export {
  ke as Select
};
